import type {
  EvalImportResolveItem,
  EvalImportResolveResponse,
  EvalImportResult,
} from './evalRelationsImportTypes';

export function mergeImportResolveResult(
  previous: EvalImportResult,
  response: EvalImportResolveResponse,
  submitted: EvalImportResolveItem[],
): EvalImportResult {
  const sentRowNos = new Set(submitted.map((item) => item.rowNo));
  const nextPending = Array.isArray(response.pending) ? response.pending : [];
  const pendingRowNos = new Set(nextPending.map((item) => item.rowNo));
  const invalidRowNos = new Set((response.invalid || []).map((item) => Number(item.rowNo)));
  const keepOld = previous.pending.filter(
    (item) =>
      !sentRowNos.has(item.rowNo) ||
      pendingRowNos.has(item.rowNo) ||
      invalidRowNos.has(item.rowNo),
  );
  const mergedPending = new Map(
    [...keepOld, ...nextPending].map((item) => [`${item.rowNo}-${item.slot}`, item]),
  );
  return {
    ...previous,
    created: previous.created + (response.created || 0),
    skipped: previous.skipped + (response.skipped || 0),
    errors: [...previous.errors, ...(response.errors || [])],
    invalid: [...previous.invalid, ...(response.invalid || [])],
    imported: [...previous.imported, ...(response.imported || [])],
    pending: Array.from(mergedPending.values()),
  };
}
